/* US fashion product page (sections/us-style-main.liquid). Vanilla JS, no dependencies. Imperial fit finder; goes to /cart after adding. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function money(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || '{{amount}} ₪';
    const n = (Number(cents) || 0) / 100;
    const amount = (Number.isInteger(n) ? String(n) : n.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function init(root) {
    if (root._spdp) return;
    root._spdp = true;
    const data = JSON.parse($('[data-spdp-json]', root).textContent);
    const variants = data.variants;
    const colorPos = Number(root.dataset.colorPos) || 0;
    const sizePos = Number(root.dataset.sizePos) || 0;
    const groups = $$('.spick__group', root);
    const firstAvail = variants.find((v) => v.available) || variants[0];

    /* ---------- selection ---------- */
    const sel = {};
    groups.forEach((g) => {
      const pos = Number(g.dataset.opt);
      const checked = $('input:checked', g);
      sel[pos] = checked ? checked.value : null;
    });
    if (colorPos && !sel[colorPos]) sel[colorPos] = firstAvail.options[colorPos - 1];

    const match = (s) => variants.find((v) => v.options.every((o, i) => !s[i + 1] || s[i + 1] === o) && Object.keys(s).every((k) => s[k]));
    const current = () => match(sel);

    /* ---------- gallery ---------- */
    const track = $('[data-sgal-track]', root);
    const slides = $$('.sgal__slide', root);
    const thumbs = $$('[data-thumb-li]', root);
    const idxEl = $('[data-sgal-i]', root);
    const nEl = $('[data-sgal-n]', root);
    const visibleSlides = () => slides.filter((s) => !s.hidden).sort((a, b) => (Number(a.style.order) || 0) - (Number(b.style.order) || 0));
    function applyColor(color, reset) {
      // colour slides of the picked colour first; other colours' slides hidden
      slides.forEach((s, i) => {
        const c = s.dataset.color;
        s.hidden = !!c && c !== color;
        s.style.order = c && c === color ? -1 : i;
      });
      thumbs.forEach((t) => {
        const s = slides.find((x) => x.dataset.mediaId === t.dataset.thumbLi);
        t.hidden = s ? s.hidden : false;
        t.style.order = s ? s.style.order : 0;
      });
      if (nEl) nEl.textContent = visibleSlides().length;
      if (reset && track && !window.matchMedia('(min-width: 990px)').matches) track.scrollTo({ left: 0, behavior: 'auto' });
      setActive(0);
    }
    function setActive(i) {
      const vis = visibleSlides();
      if (idxEl) idxEl.textContent = Math.min(i + 1, vis.length);
      const id = vis[i] && vis[i].dataset.mediaId;
      $$('[data-thumb]', root).forEach((b) => b.classList.toggle('is-on', b.dataset.thumb === id));
    }
    function snap(s, behavior) {
      if (!s || !track) return;
      if (window.matchMedia('(min-width: 990px)').matches) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const a = s.getBoundingClientRect(), b = track.getBoundingClientRect();
      track.scrollBy({ left: rtl ? a.right - b.right : a.left - b.left, behavior });
    }
    function goTo(i) {
      const vis = visibleSlides();
      const s = vis[Math.max(0, Math.min(vis.length - 1, i))];
      if (!s) return;
      if (window.matchMedia('(min-width: 990px)').matches) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else snap(s, 'smooth');
    }
    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const vis = visibleSlides();
          const mid = track.getBoundingClientRect().left + track.clientWidth / 2;
          let best = 0, bestD = Infinity;
          vis.forEach((s, i) => { const r = s.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); if (d < bestD) { bestD = d; best = i; } });
          setActive(best);
        });
      }, { passive: true });
    }
    $$('[data-thumb]', root).forEach((b) => b.addEventListener('click', () => {
      const vis = visibleSlides();
      goTo(vis.findIndex((s) => s.dataset.mediaId === b.dataset.thumb));
    }));
    const cur = () => Number(idxEl ? idxEl.textContent : 1) - 1;
    $('[data-sgal-prev]', root)?.addEventListener('click', () => goTo(cur() - 1));
    $('[data-sgal-next]', root)?.addEventListener('click', () => goTo(cur() + 1));

    /* ---------- price + availability ---------- */
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare]', root);
    const saveEl = $('[data-save]', root);
    const saveAmt = $('[data-save-amount]', root);
    const buyBtn = $('[data-sbuy]', root);
    const buyLabel = $('[data-sbuy-label]', root);
    const buySum = $('[data-sbuy-sum]', root);
    const stickPrice = $('[data-stick-price]', root);
    const unitVariant = () => current() || variants.find((v) => (!colorPos || v.options[colorPos - 1] === sel[colorPos]) && v.available) || firstAvail;

    function refreshSizes() {
      if (!sizePos) return;
      $$('[data-size-group] input', root).forEach((inp) => {
        const s = { ...sel, [sizePos]: inp.value };
        const v = match(s);
        const ok = !!(v && v.available);
        inp.closest('.ssize').classList.toggle('is-out', !ok);
        inp.disabled = !ok;
        if (!ok && inp.checked) { inp.checked = false; sel[sizePos] = null; }
      });
      const lab = $('[data-size-group] [data-opt-value]', root);
      if (lab) lab.textContent = sel[sizePos] || lab.dataset.empty;
    }

    function refreshPrice() {
      const v = unitVariant();
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      const has = v.compare > v.price;
      if (compareEl) { compareEl.hidden = !has; compareEl.textContent = money(v.compare); }
      if (saveEl) saveEl.hidden = !has;
      if (saveAmt) saveAmt.textContent = money(v.compare - v.price);
      if (stickPrice) stickPrice.textContent = money(v.price);
      refreshBundle();
    }

    /* ---------- bundle ---------- */
    const bundle = $('[data-sbundle]', root);
    const extraBox = bundle && $('[data-extra]', bundle);
    let tier = 1;
    const extras = []; // [{color, size}]
    const optionValues = (pos) => [...new Set(variants.map((v) => v.options[pos - 1]))];
    function tierTotal(n, unit, compare) {
      const off = n === 2 ? Number(bundle.dataset.off2) : n === 3 ? Number(bundle.dataset.off3) : 0;
      return { total: unit * n - off, strike: (compare > unit ? compare : unit) * n, off };
    }
    function refreshBundle() {
      const v = unitVariant();
      let total = v ? v.price : 0;
      if (bundle && v) {
        $$('[data-tier]', bundle).forEach((t) => {
          const n = Number(t.dataset.tier);
          const r = tierTotal(n, v.price, v.compare);
          $('[data-tier-total]', t).textContent = money(r.total);
          const strike = $('[data-tier-strike]', t);
          strike.textContent = r.strike > r.total ? money(r.strike) : '';
          $('[data-tier-sub]', t).textContent = (bundle.dataset.each || '[price]').replace('[price]', money(Math.round(r.total / n)));
          t.classList.toggle('is-on', n === tier);
        });
        total = tierTotal(tier, v.price, v.compare).total;
      }
      const pair = pairState();
      if (pair) total += pair.price;
      if (buySum) buySum.textContent = v && v.available ? '· ' + money(total) : '';
      if (buyBtn) {
        buyBtn.disabled = !(v && v.available);
        if (buyLabel) buyLabel.textContent = v && v.available ? root.dataset.tAdd : root.dataset.tSoldout;
      }
    }
    function extraRow(i) {
      const e = extras[i];
      const row = document.createElement('div');
      row.className = 'sextra';
      const label = (bundle.dataset.item || 'פריט [n]').replace('[n]', i + 2);
      const mk = (pos, val) => {
        const s = document.createElement('select');
        s.className = 'sextra__sel';
        if (pos === sizePos) {
          const o = document.createElement('option'); o.value = ''; o.textContent = $('[data-size-group] [data-opt-value]', root)?.dataset.empty || 'מידה'; s.appendChild(o);
        }
        optionValues(pos).forEach((val2) => { const o = document.createElement('option'); o.value = val2; o.textContent = val2; s.appendChild(o); });
        s.value = val || '';
        s.addEventListener('change', () => { if (pos === colorPos) e.color = s.value; else e.size = s.value; row.classList.remove('is-err'); });
        return s;
      };
      const t = document.createElement('span'); t.className = 'sextra__n'; t.textContent = label; row.appendChild(t);
      if (colorPos) row.appendChild(mk(colorPos, e.color));
      if (sizePos) row.appendChild(mk(sizePos, e.size));
      return row;
    }
    function renderExtras() {
      if (!extraBox) return;
      while (extras.length < tier - 1) extras.push({ color: sel[colorPos] || null, size: sel[sizePos] || null });
      extras.length = Math.max(0, tier - 1);
      extraBox.innerHTML = '';
      extras.forEach((_, i) => extraBox.appendChild(extraRow(i)));
      extraBox.hidden = tier < 2;
    }
    bundle?.addEventListener('change', (e) => {
      if (!e.target.matches('input[type="radio"]')) return;
      tier = Number(e.target.value);
      renderExtras();
      refreshBundle();
    });

    /* ---------- complete the look ---------- */
    const pairBox = $('[data-spair]', root);
    function pairState() {
      if (!pairBox) return null;
      const on = $('[data-pair-check]', pairBox).checked;
      const s = $('[data-pair-select]', pairBox);
      pairBox.classList.toggle('is-on', on);
      if (!on) return null;
      const opt = s.selectedOptions[0];
      return { id: s.value ? Number(s.value) : null, price: opt && opt.dataset.price ? Number(opt.dataset.price) : 0, select: s };
    }
    pairBox?.addEventListener('change', (e) => {
      if (e.target.matches('[data-pair-check]') && e.target.checked) {
        const s = $('[data-pair-select]', pairBox);
        if (!s.value) setTimeout(() => s.focus(), 50);
      }
      pairBox.classList.remove('is-err');
      refreshBundle();
    });

    /* ---------- options change ---------- */
    groups.forEach((g) => g.addEventListener('change', (e) => {
      if (!e.target.matches('input[type="radio"]')) return;
      const pos = Number(g.dataset.opt);
      sel[pos] = e.target.value;
      const lab = $('[data-opt-value]', g);
      if (lab) lab.textContent = e.target.value;
      if (pos === sizePos) { $('[data-size-err]', root).hidden = true; g.classList.remove('is-err'); }
      if (pos === colorPos) applyColor(e.target.value, true);
      refreshSizes();
      refreshPrice();
      const v = current();
      if (v) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
      }
    }));

    /* ---------- add to cart ---------- */
    const err = $('[data-sbuy-err]', root);
    function needSize() {
      const g = $('[data-size-group]', root);
      if (!g) return;
      $('[data-size-err]', root).hidden = false;
      g.classList.remove('is-err'); void g.offsetWidth; g.classList.add('is-err');
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    async function addToCart() {
      if (err) err.hidden = true;
      const v = current();
      if (!v) { needSize(); return; }
      const items = [{ id: v.id, quantity: 1 }];
      for (let i = 0; i < extras.length; i++) {
        const e = extras[i];
        const s = {}; if (colorPos) s[colorPos] = e.color; if (sizePos) s[sizePos] = e.size;
        const ev = match(s);
        if (!ev || !ev.available) { extraBox.children[i]?.classList.add('is-err'); extraBox.children[i]?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        items.push({ id: ev.id, quantity: 1 });
      }
      const pair = pairState();
      if (pair) {
        if (!pair.id) { pairBox.classList.add('is-err'); pair.select.focus(); return; }
        items.push({ id: pair.id, quantity: 1 });
      }
      const merged = [];
      items.forEach((it) => { const f = merged.find((m) => m.id === it.id); if (f) f.quantity += 1; else merged.push({ ...it }); });
      buyBtn.classList.add('is-loading');
      try {
        const C = window.ThemeCart;
        const res = await fetch((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: merged, sections: C ? C.sectionIds() : undefined, sections_url: location.pathname }),
        });
        const d = await res.json().catch(() => ({}));
        if (!res.ok || d.status) throw new Error(d.description || d.message || 'שגיאה');
        if (C && d.sections) C.render(d.sections);
        buyLabel.textContent = root.dataset.tAdded;
        setTimeout(() => { buyLabel.textContent = root.dataset.tAdd; }, 1800);
        if (!C) { location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart'; return; }
        if (!document.body.classList.contains('template-cart')) $('[data-cart-opener]', root)?.click();
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
      } finally {
        buyBtn.classList.remove('is-loading');
      }
    }
    buyBtn?.addEventListener('click', addToCart);

    /* ---------- sticky bar ---------- */
    const stick = $('[data-sstick]', root);
    if (stick && buyBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        stick.classList.toggle('is-on', show);
        stick.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-stick-btn]', stick).tabIndex = show ? 0 : -1;
      });
      io.observe(buyBtn);
      $('[data-stick-btn]', stick).addEventListener('click', () => {
        if (!current()) { needSize(); return; }
        addToCart();
      });
    }

    /* ---------- fit finder ---------- */
    const dlg = $('[data-fit]', root);
    if (dlg) {
      const open = () => { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); calc(); };
      $$('[data-fit-open]', root).forEach((b) => b.addEventListener('click', open));
      $('[data-fit-close]', dlg).addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      $$('[data-fit-tab]', dlg).forEach((b) => b.addEventListener('click', () => {
        $$('[data-fit-tab]', dlg).forEach((x) => x.classList.toggle('is-on', x === b));
        $$('[data-fit-panel]', dlg).forEach((p) => { p.hidden = p.dataset.fitPanel !== b.dataset.fitTab; });
      }));
      const rows = ($('[data-finder]', dlg).dataset.finder || '').split(/<br\s*\/?>/i).map((l) => l.split('|').map((c) => c.trim())).filter((r) => r[0] && r[1]).map((r) => ({ size: r[0], max: Number(r[1]) }));
      const h = $('[data-in-h]', dlg), w = $('[data-in-w]', dlg);
      const outH = $('[data-out-h]', dlg), outW = $('[data-out-w]', dlg), outS = $('[data-fit-size]', dlg);
      let rec = null;
      function calc() {
        const imp = root.dataset.units === 'imperial';
        outH.textContent = imp ? `${Math.floor(h.value / 12)}'${h.value % 12}"` : h.value; outW.textContent = w.value;
        if (!rows.length) return;
        const W = Number(w.value), H = Number(h.value);
        let i = rows.findIndex((r) => W <= r.max);
        if (i < 0) i = rows.length - 1;
        const lo = i ? rows[i - 1].max : rows[0].max - 10;
        const pos = (W - lo) / Math.max(1, rows[i].max - lo);
        const pref = Number(($('input[name^="pref-"]:checked', dlg) || {}).value || 0);
        if (pref < 0 && pos < 0.35 && i > 0) i -= 1;
        if (pref > 0 && pos > 0.45 && i < rows.length - 1) i += 1;
        if (pref === 0 && H >= Number(root.dataset.tall || 178) && pos > 0.6 && i < rows.length - 1) i += 1;
        rec = rows[i].size;
        outS.textContent = rec;
      }
      [h, w].forEach((x) => x.addEventListener('input', calc));
      dlg.addEventListener('change', calc);
      $('[data-fit-apply]', dlg).addEventListener('click', () => {
        const inp = $$('[data-size-group] input', root).find((x) => x.value.toUpperCase() === String(rec).toUpperCase());
        if (inp && !inp.disabled) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        dlg.close();
      });
    }

    applyColor(sel[colorPos]);
    refreshSizes();
    refreshPrice();
    renderExtras();
  }

  const boot = (scope) => $$('[data-spdp]', scope).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
